export default __webpack_public_path__ + "static/media/upload_icn.8be7903d.svg";